import { type DateRange } from 'react-day-picker';

import {
  type DateRangePreset,
  DateRangePicker,
  useDateRangePresetLabels,
} from '@/components/ui/date-range-picker';

import { DateRangePanel } from '../date-range-panel';
interface DateRangeDisplayProps {
  appliedDate: DateRange;
  appliedPreset: DateRangePreset;
  onApply: (params: { preset?: DateRangePreset; range: DateRange }) => void;
  /** True while a newly-applied range/preset is still being fetched. */
  isPending?: boolean;
}

export function DateRangeDisplay({
  appliedDate,
  appliedPreset,
  onApply,
  isPending,
}: DateRangeDisplayProps) {
  const presetLabels = useDateRangePresetLabels();
  const presetSubtitle =
    appliedPreset !== 'custom' ? presetLabels[appliedPreset] : null;

  return (
    <DateRangePanel subtitle={presetSubtitle}>
      <div className="flex items-center rounded-lg p-2 outline-1 outline-offset-[-1px] outline-neutral-200">
        <DateRangePicker
          selectedDate={appliedDate}
          setSelectedDate={() => {}}
          selectedPreset={appliedPreset}
          onPresetChange={() => {}}
          onApply={onApply}
          showPresetInTrigger={false}
          isLoading={isPending}
          className="text-fx-neutral-900 [&_svg]:text-fx-neutral-600 h-auto gap-1 p-0! font-medium hover:bg-transparent"
        />
      </div>
    </DateRangePanel>
  );
}
